export function PercentIcon() {
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5 12.5L10 2.5'
        stroke='#021542'
        strokeWidth='1.3'
        strokeLinecap='round'
      />
      <path
        d='M4.375 6.875C5.41053 6.875 6.25 6.03553 6.25 5C6.25 3.96447 5.41053 3.125 4.375 3.125C3.33947 3.125 2.5 3.96447 2.5 5C2.5 6.03553 3.33947 6.875 4.375 6.875Z'
        stroke='#021542'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.625 11.875C11.6606 11.875 12.5 11.0356 12.5 10C12.5 8.96444 11.6606 8.125 10.625 8.125C9.58944 8.125 8.75 8.96444 8.75 10C8.75 11.0356 9.58944 11.875 10.625 11.875Z'
        stroke='#021542'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
